import axios from "axios";
import endpoints from "../utils/endpoints";

const scan = async (params: any) => {
  const url = endpoints.CHECK;
  const { data: response } = await axios.post(url, params);
  return response;
};

const validateToken = async (params: any) => {
  const url = endpoints.CHECK + "/validate";
  const { data: response } = await axios.get(url, { params });
  return response;
};

const service = {
  scan,
  validateToken,
};

export default service;
